define('viewModels/widgets/MediaTypePickerView',[
    'lib/knockout',
    'services/analyticsService',
    'viewModels/ViewModel'
], function (
    ko,
    analyticsService,
    ViewModel
) {
    'use strict';

    // ===============================================================================
    // Constants
    // ===============================================================================

    var VOICE_MEDIA_TYPE_KEY  = "voice";
    var CHAT_MEDIA_TYPE_KEY   = "chat";
    var EMAIL_MEDIA_TYPE_KEY   = "email";
    var CALLBACK_MEDIA_TYPE_KEY = "callback";
    var MESSAGE_MEDIA_TYPE_KEY = "message";

    var selectedTypeMap = {};

    selectedTypeMap[VOICE_MEDIA_TYPE_KEY] = {
        "cssClass": "media-type-voice",
        "icon": "fa-phone",
        "messageKey": "mediaTypes.voice"
    };

    selectedTypeMap[CHAT_MEDIA_TYPE_KEY] = {
        "cssClass": "media-type-chat",
        "icon": "fa-comment",
        "messageKey": "mediaTypes.chat"
    };

    selectedTypeMap[EMAIL_MEDIA_TYPE_KEY] = {
        "cssClass": "media-type-email",
        "icon": "fa-envelope-o",
        "messageKey": "mediaTypes.email"
    };

    selectedTypeMap[CALLBACK_MEDIA_TYPE_KEY] = {
        "cssClass": "media-type-callback",
        "icon": "pc pc-icon-callback",
        "messageKey": "mediaTypes.callback"
    };

    selectedTypeMap[MESSAGE_MEDIA_TYPE_KEY] = {
        "cssClass": "media-type-message",
        "messageKey": "mediaTypes.message"
    };

    // ===============================================================================
    // Class Definition
    // ===============================================================================

    /**
     * The MediaTypePickerView provides a viewmodel that will back a template designed to
     * allow a user to select the analytics media type (voice, chat, etc.) of data they
     * wish to view.
     *
     * The main way to access the selected media type of this view is the
     * "selectedMediaTypeValue" attribute. This attribute will return a string that
     * represents the value that analyticsService expects to send to the backend for the
     * media type of data to query.
     */
    var MediaTypePickerView = ViewModel.extend(function () {
        // ===============================================================================
        // Private Attributes
        // ===============================================================================

        var self = this;

        var selectedMediaType = ko.observable(VOICE_MEDIA_TYPE_KEY);

        // ===============================================================================
        // Public Methods
        // ===============================================================================

        self.selectedMediaTypeValue = self.computed(function () {
            var value = analyticsService.MEDIA_TYPES.VOICE;

            if (selectedMediaType() === CHAT_MEDIA_TYPE_KEY) {
                value =  analyticsService.MEDIA_TYPES.CHAT;
            } else if (selectedMediaType() === EMAIL_MEDIA_TYPE_KEY) {
                value = analyticsService.MEDIA_TYPES.EMAIL;
            } else if (selectedMediaType() === CALLBACK_MEDIA_TYPE_KEY) {
                value = analyticsService.MEDIA_TYPES.CALLBACK;
            } else if (selectedMediaType() === MESSAGE_MEDIA_TYPE_KEY) {
                value = analyticsService.MEDIA_TYPES.MESSAGE;
            }

            return value;
        });

        // ===============================================================================
        // Template Attributes
        // ===============================================================================

        self.isSelectingMediaType = ko.observable(false); // determine if the layout dropdown is shown

        self.selectedMediaTypeObj = self.computed(function () {
            return selectedTypeMap[selectedMediaType()];
        });

        // ===============================================================================
        // Event Callbacks
        // ===============================================================================

        //
        // Media Type Selection
        //
        self.selectVoice = function () {
            selectedMediaType(VOICE_MEDIA_TYPE_KEY);
            self.isSelectingMediaType(false);
        };

        self.selectChat = function () {
            selectedMediaType(CHAT_MEDIA_TYPE_KEY);
            self.isSelectingMediaType(false);
        };

        self.selectEmail = function () {
            selectedMediaType(EMAIL_MEDIA_TYPE_KEY);
            self.isSelectingMediaType(false);
        };

        self.selectCallback = function () {
            selectedMediaType(CALLBACK_MEDIA_TYPE_KEY);
            self.isSelectingMediaType(false);
        };

        self.selectMessage = function () {
            selectedMediaType(MESSAGE_MEDIA_TYPE_KEY);
            self.isSelectingMediaType(false);
        };
    });

    return MediaTypePickerView;


});

